import React from "react";
import { Link } from "react-router-dom";
import { getPath } from "common/routing";
import AccelaLogo from "../../../../images/integrations/accela-logo.png";
import ArcGISLogo from "../../../../images/integrations/arcgis-logo.png";
import { spacing } from "../../../../stitches.config";
import { Box, FlexColumn, FlexRow } from "../../../Common/__styles__/Layout";
import { Body, Title } from "../../../Common/Typography";

export const Integrations = () => {
  return (
    <Box>
      <FlexColumn style={{ padding: spacing.l.value, gap: spacing.l.value }}>
        <FlexColumn style={{ gap: spacing.xs.value }}>
          <Title size="small" type="semiBold">
            Integrations
          </Title>
          <Body size="default" type="regular" color="contentSecondary">
            Connect your services to Forerunner to share information.
          </Body>
        </FlexColumn>

        <FlexColumn>
          <Body size="large" type="emphasis">
            All apps
          </Body>
          <IntegrationItem integration="accela" />
          <IntegrationItem integration="arcgis" />
        </FlexColumn>
      </FlexColumn>
    </Box>
  );
};

const integrationsConfigs = {
  accela: {
    logoSrc: AccelaLogo,
    logoAlt: "Accela",
    url: getPath("accela"),
    title: "Accela",
    subtitle:
      "Share data between Forerunner and Accela to streamline your workflows",
  },
  arcgis: {
    logoSrc: ArcGISLogo,
    logoAlt: "ArcGIS",
    url: getPath("arcGISExports"),
    title: "ArcGIS",
    subtitle: "Push Forerunner saved views to ArcGIS",
  },
};

const IntegrationItem = ({
  integration,
}: {
  integration: keyof typeof integrationsConfigs;
}) => {
  const config = integrationsConfigs[integration];
  return (
    <FlexRow
      style={{
        paddingTop: spacing.m.value,
        paddingBottom: spacing.m.value,
        gap: spacing.m.value,
      }}
    >
      <img src={config.logoSrc} alt={config.logoAlt} width={40} height={40} />
      <Link to={config.url} style={{ textDecoration: "none" }}>
        <FlexColumn>
          <Body size="default" type="emphasis" as="span">
            {config.title}
          </Body>
          <Body size="small" type="regular" color="contentSecondary">
            {config.subtitle}
          </Body>
        </FlexColumn>
      </Link>
    </FlexRow>
  );
};
